import React, { FC, useRef } from "react";
import "./Accordion.css";
import editIcon from "../../assets/edit-icon.svg";
import caret from "../../assets/caret.svg";

interface AccordionProps {
  children: React.ReactNode;
  header: string;
  allowEdit: boolean;
  // eslint-disable-next-line no-unused-vars
  goToStep: (number: number) => void;
}

const Accordion: FC<AccordionProps> = ({ children, header, allowEdit, goToStep }) => {
  const [active, setActive] = React.useState(false);
  const toggle = () => setActive(!active);
  const dom = useRef<HTMLDivElement>(null);

  return (
    <div className="accordion">
      <div className={`item ${active ? "active" : ""}`}>
        <div className="header" onClick={toggle} onKeyDown={() => {}} tabIndex={0} role="button">
          <div className="label">{header}</div>
          <span className="icon">
            <img
              src={editIcon}
              alt="Edit Icon"
              onClick={() => goToStep(0)}
              onKeyDown={() => {}}
              tabIndex={0}
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
              role="button"
              style={{
                display: allowEdit ? "block" : "none",
              }}
            />
            {active ? (
              <img src={caret} alt="caret" className="caret-down" />
            ) : (
              <img src={caret} alt="caret" className="caret-up" />
            )}
          </span>
        </div>
        <div className={`divider ${active ? "show" : "hide"}`} />
        <div
          ref={dom}
          className="details"
          style={
            active
              ? {
                  height: dom.current === null ? "599px" : dom.current.scrollHeight,
                  transition: "height 1s ease",
                }
              : { height: "0px", transition: "height 1s ease" }
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
